import { render, staticRenderFns } from "./ExcipientStock.vue?vue&type=template&id=3dc1e002&scoped=true&"
import script from "./ExcipientStock.vue?vue&type=script&lang=js&"
export * from "./ExcipientStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1e002",
  null
  
)

export default component.exports